import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type DeleteFloorLayoutsOptions = {
  mutationConfig?: MutationConfig<typeof deleteFloorLayouts>;
};

type DeleteFloorLayouts = {
  projectId: string;
  layoutIds: string[];
};

const deleteFloorLayouts = ({ projectId, layoutIds }: DeleteFloorLayouts) => {
  return extractData(api.projects({ id: projectId }).layouts.batch.delete({ layoutIds }));
};

export const useDeleteFloorLayouts = ({ mutationConfig }: DeleteFloorLayoutsOptions = {}) => {
  return useMutation({ ...mutationConfig, mutationFn: deleteFloorLayouts });
};
